import { Button, Tooltip } from 'antd'
import { Link, useLocation } from 'react-router-dom'
import { useCurrentUser } from '@/hooks/use-auth'
import { TASK_WORKSPACES } from '@/lib/task-workspaces'

/** A management destination keeps the entire source URL for a reversible round trip. */
export function TaskManagementLink({ taskKey, row, compact = false }: { taskKey?: string; row?: any; compact?: boolean }) {
  const location = useLocation()
  const { data: user } = useCurrentUser()
  const key = taskKey || (location.pathname.startsWith('/dashboard/tasks/') ? location.pathname.split('/').pop() : undefined)
  const workspace = key ? TASK_WORKSPACES[key] : undefined
  if (!workspace || !user?.roles?.some((role: string) => workspace.roles.includes(role))) return null
  const isExternalMail = !!key?.startsWith('mail-') && (row?.type === 'OUTSOURCE' || row?.orderType === 'OUTSOURCE' || row?.order?.type === 'OUTSOURCE')
  const management = isExternalMail ? '/dashboard/service/outsource-workbench' : key === 'monthly' && user.roles?.includes('ADMIN') ? '/dashboard/finance/monthly' : workspace.management
  const managementLabel = isExternalMail ? '代送检测管理' : key === 'monthly' && user.roles?.includes('ADMIN') ? '月结管理' : workspace.managementLabel
  const target = new URL(management, window.location.origin)
  if (!row) {
    for (const [name,value] of new URLSearchParams(location.search)) {
      if (/^(task|history)(Keyword|Center|CenterName|From|To|Serial|Urgent)$/.test(name)) target.searchParams.set(name,value)
    }
  }
  target.searchParams.set('returnTo', location.pathname + location.search + location.hash)
  if (row) {
    const orderId = row.orderId || row.order?.id || (['assign', 'dispatch', 'monthly'].includes(key!) ? row.id : undefined)
    if (orderId) {
      target.searchParams.set('orderDetail', orderId)
      target.searchParams.set('orderRole', workspace.roles.find(role => role !== 'ADMIN') || 'ADMIN')
    }
    if (row.invoiceId) target.searchParams.set('invoiceId', row.invoiceId)
    if (key === 'payment-claim' && row.id) target.searchParams.set('paymentId', row.id)
    if (key === 'voucher-audit' && row.id) { target.searchParams.set('paymentId', row.id); target.searchParams.set('tab', 'vouchers') }
    if (row.bizType === 'INVOICE' && row.bizId) { target.searchParams.set('invoiceId', row.bizId); target.searchParams.set('tab', 'review') }
    if (row.bizId && workspace.management.includes('workflow-records')) target.searchParams.set('bizId', row.bizId)
  }
  return <Tooltip title={`进入${managementLabel}${row ? '并定位当前业务事项' : '，可继续查询和办理'}；返回时保留当前任务筛选`}>
    <Link to={target.pathname + target.search} onClick={event => event.stopPropagation()}>
      <Button size={compact ? 'small' : 'middle'} type={compact ? 'link' : 'default'}>{compact ? '管理' : `进入${managementLabel}`}</Button>
    </Link>
  </Tooltip>
}
